// extracted by mini-css-extract-plugin
export default {"box":"Find_box__4swxj","imge":"Find_imge__5CSpK","des":"Find_des__27pD+","bydiv":"Find_bydiv__6lska","by":"Find_by__3C+1E","byname":"Find_byname__1El67"};